import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, FileText, ShoppingCart, Search } from "lucide-react";
import { Button } from "../../components/ui/button";

// AI Assistant has been audited as scripted/mock — until the real
// Claude Sonnet 4.5 wiring lands, this page advertises the capability
// without faking a conversation. Keeping the route alive avoids broken
// links from the App Store / sidebar.
const HIGHLIGHTS = [
  { icon: FileText,    title: "PO reader",     desc: "Drop a supplier PDF — we extract every line, match SKUs, draft the order." },
  { icon: ShoppingCart, title: "Order builder", desc: "Reorder past baskets in one prompt. Smart MOQ + tier-pricing aware." },
  { icon: Search,      title: "Account search", desc: "Find any invoice, order, supplier or shipment by plain-English question." },
];

export default function BuyerAI() {
  return (
    <div className="min-h-[80vh] grid place-items-center px-8" data-testid="buyer-ai-coming-soon">
      <div className="max-w-2xl text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-foreground/5 border border-border text-[11px] mono uppercase tracking-widest text-foreground/60">
          <Sparkles className="w-3 h-3" />
          Coming soon · Powered by Verqo AI
        </div>
        <h1 className="display text-4xl mt-6 leading-tight">verqo AI Assistant</h1>
        <p className="text-foreground/65 mt-3 leading-relaxed">
          A wholesale-native copilot that reads your POs, drafts orders against your real catalog,
          and answers anything about your account in plain English. We're tuning the underwriter
          context window before flipping this on for everyone.
        </p>

        <div className="grid sm:grid-cols-3 gap-3 mt-10 text-left">
          {HIGHLIGHTS.map((h, i) => (
            <div key={i} data-testid={`ai-highlight-${i}`}
              className="rounded-2xl border border-border bg-white p-5">
              <div className="w-9 h-9 rounded-xl bg-foreground/5 grid place-items-center"><h.icon className="w-4 h-4" /></div>
              <div className="mt-3 text-sm font-medium">{h.title}</div>
              <div className="text-xs text-foreground/55 mt-1 leading-relaxed">{h.desc}</div>
            </div>
          ))}
        </div>

        <p className="text-[13px] text-foreground/50 mt-10">
          Want first access? Tell us in Help &amp; Support — we'll email you the moment it lands.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
          <Button asChild className="rounded-full bg-foreground text-background hover:bg-foreground/90 h-11 px-5" data-testid="ai-back-dashboard">
            <Link to="/buyer">
              Back to dashboard <ArrowRight className="w-4 h-4 ml-1.5" />
            </Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full h-11 px-5" data-testid="ai-browse-apps">
            <Link to="/buyer/apps">Browse the App Store</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
